import { Injectable } from '@angular/core';
import { HttpService } from "../core/http/http.service";
import { ISupplierAddress } from '../_entities';
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";

@Injectable()
export class SupplierAddressService extends DataAccessServiceBase<ISupplierAddress> {
    private supplierId: number;

    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return `api/supplier/${this.supplierId}/address`;
    }

    getAddress(supplierId: number, id: number): Promise<ISupplierAddress> {
        this.supplierId = supplierId;
        return super.getItem(id);
    }

    getAddresses(supplierId: number): Promise<ISupplierAddress[]> {
        this.supplierId = supplierId;
        return super.getItems();
    }

    patchAddress(supplierId: number, addressId: any, patches: any, oldValue: any): Promise<ISupplierAddress> {
        this.supplierId = supplierId;
        return super.patchItem(addressId, patches, oldValue);
    }

    addAddress(supplierId: number, address: ISupplierAddress): Promise<ISupplierAddress> {
        this.supplierId = supplierId;
        return super.addItem(address);
    }

    deleteAddress(supplierId: number, addressId: any): Promise<void> {
        this.supplierId = supplierId;
        return super.deleteItem(addressId);
    }

}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/supplier-address.service.ts